const NewStandardAbilityCertificationInPerson = () => import('frontend/pages/settings/standards/NewStandardAbilityCertificationInPerson.vue')
const PeopleBulkImportPage = () => import('frontend/presentation/people/people-bulk-import/views/PeopleBulkImportPage.vue')
const SettingsDepartmentsPage = () => import('frontend/pages/settings/DepartmentsPage')
const SettingsPeopleConfigPage = () => import('frontend/pages/settings/people/SettingsPeopleConfigPage')
const SettingsPeoplePage = () => import('frontend/pages/settings/people/SettingsPeoplePage')
const SettingsPersonDetailsPage = () => import('frontend/pages/settings/people/SettingsPersonDetailsPage')
const SettingsRolesDetailsPage = () => import('frontend/pages/settings/SettingsRolesDetailsPage')
const SettingsRolesPage = () => import('frontend/pages/settings/SettingsRolesPage')
const SettingsTeamsPage = () => import('frontend/pages/settings/SettingsTeamsPage')
const StandardAbilityCertificationInPersonDetails = () => import('frontend/pages/settings/standards/StandardAbilityCertificationInPersonDetails')
const StandardAbilityCertificationInPersonRouterPage = () => import('frontend/pages/settings/standards/StandardAbilityCertificationInPersonRouterPage')
const BackButton = () => import('frontend/components/core/BackButton')

import * as constants from 'frontend/routes/constants'
import RemoteFilters from 'frontcore/presentation/remote-filters/views/RemoteFilters.vue'
import { PEOPLE_FILTERS } from 'frontend/constants/filterUrls'
import { SETTINGS_CARDS_TOKENS } from 'frontend/constants/settings'

export default [
  {
    path: 'departments',
    name: SETTINGS_CARDS_TOKENS.peopleDepartments.name,
    components: {
      default: SettingsDepartmentsPage,
    },
  },
  {
    path: SETTINGS_CARDS_TOKENS.importPeople.name,
    name: SETTINGS_CARDS_TOKENS.importPeople.name,
    components: {
      default: PeopleBulkImportPage,
    },
  },
  {
    path: 'people',
    name: SETTINGS_CARDS_TOKENS.peopleSettings.name,
    components: {
      default: SettingsPeoplePage,
      filters: RemoteFilters,
      back: BackButton,
    },
    props: {
      back: { to: SETTINGS_CARDS_TOKENS.settingsOverview.name },
      default: { source: 'people' },
      filters: { filterURL: PEOPLE_FILTERS },
    },
  },
  {
    path: 'people/:id/config',
    name: 'settings-people-config',
    components: {
      default: SettingsPeopleConfigPage,
    },
    props: { default: { source: 'people' } },
  },
  {
    path: 'people/details/:id',
    name: constants.PEOPLE_DETAILS_ROUTE_NAME,
    props: {
      default: (routerInstance) => {
        return {
          id: Number(routerInstance.params.id),
        }
      },
    },
    components: {
      default: SettingsPersonDetailsPage,
    },
  },
  {
    path: 'people/details/:personId/certifications-in-person/',
    components: {
      default: StandardAbilityCertificationInPersonRouterPage,
    },
    children: [
      {
        path: 'new',
        name: constants.CERTIFICATION_IN_PERSON_NEW_ROUTE_NAME,
        props: {
          default: (routerInstance) => {
            return {
              personId: Number(routerInstance.params.personId),
            }
          },
        },
        components: {
          default: NewStandardAbilityCertificationInPerson,
        },
      },
      {
        path: ':certificationInPersonToRenewId/renew',
        name: constants.CERTIFICATION_IN_PERSON_RENEW_ROUTE_NAME,
        props: {
          default: (routerInstance) => {
            return {
              personId: Number(routerInstance.params.personId),
              certificationInPersonToRenewId: Number(routerInstance.params.certificationInPersonToRenewId),
            }
          },
        },
        components: {
          default: NewStandardAbilityCertificationInPerson,
        },
      },
      {
        path: ':certificationInPersonId/details',
        name: constants.PEOPLE_CERTIFICATION_DETAILS_ROUTE_NAME,
        props: {
          default: (routerInstance) => {
            return {
              personId: Number(routerInstance.params.personId),
              certificationInPersonId: Number(routerInstance.params.certificationInPersonId),
            }
          },
        },
        components: {
          default: StandardAbilityCertificationInPersonDetails,
        },
      },
    ],
  },
  {
    path: 'roles',
    name: 'settings-roles',
    component: SettingsRolesPage,
  },
  {
    path: 'teams',
    name: SETTINGS_CARDS_TOKENS.peopleTeams.name,
    component: SettingsTeamsPage,
  },
  {
      path: 'roles/:id',
      name: SETTINGS_CARDS_TOKENS.roleSettingsDetails.name,
      component: SettingsRolesDetailsPage,
  },
]
